import http from "./httpservices";
import GetCookieByName from "../../hooks/GetCookie";

const endPoint = "report-groups";

function authHeaders() {
  return { headers: { "x-auth-token": JSON.parse(GetCookieByName("auth"))["token"] } };
}

export async function FetchReportGroups() {
  return http.get(`${endPoint}`, authHeaders());
}

// Public like FetchReportDetails in reportServices.js — must also work for an
// anonymous visitor on the group's shareable link, so the auth header is
// attached only when a token exists, never required.
function optionalAuthHeaders() {
  const headers = {};
  try {
    const token = JSON.parse(GetCookieByName("auth"))?.token;
    if (token) headers["x-auth-token"] = token;
  } catch { /* no auth cookie — route is public, proceed without header */ }
  return { headers };
}

export async function FetchReportGroupSummary(groupId) {
  return http.get(`${endPoint}/${groupId}/summary`, optionalAuthHeaders());
}

export async function FetchReportGroupSnapshots(groupId) {
  return http.get(`${endPoint}/${groupId}/snapshots`, optionalAuthHeaders());
}

export async function CreateReportGroup(payload) {
  return http.post(`${endPoint}`, payload, authHeaders());
}

export async function RenameReportGroup(groupId, name) {
  return http.patch(`${endPoint}/${groupId}`, { name }, authHeaders());
}

export async function ArchiveReportGroup(groupId, isArchived) {
  return http.patch(`${endPoint}/${groupId}`, { isArchived }, authHeaders());
}

export async function DeleteReportGroup(groupId) {
  return http.delete(`${endPoint}/${groupId}`, authHeaders());
}

export async function AttachReportToGroup(groupId, reportId) {
  return http.post(`${endPoint}/${groupId}/reports/${reportId}`, {}, authHeaders());
}

export async function DetachReportFromGroup(groupId, reportId) {
  return http.delete(`${endPoint}/${groupId}/reports/${reportId}`, authHeaders());
}

export default {
  FetchReportGroups,
  FetchReportGroupSummary,
  FetchReportGroupSnapshots,
  CreateReportGroup,
  RenameReportGroup,
  ArchiveReportGroup,
  DeleteReportGroup,
  AttachReportToGroup,
  DetachReportFromGroup,
};
